import { type LoggedInUser } from '@/hooks/queries/useMe'
import { store } from '@/stores'
import {
  activeModuleAtom,
  getActiveModule,
  MODULE_CONFIG,
  resolveHomeModule,
} from '@/stores/module'
import { getUserAccessibleModules } from '@repo/permissions'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/')({
  beforeLoad: ({ context, location }) => {
    // Fetched by the parent guard. Absent only when it bailed on an invalid session, with the login
    // redirect already under way, so do not call the API again with that session.
    const me = context.queryClient.getQueryData<LoggedInUser>(['me'])
    if (!me) return

    const storedModule = getActiveModule()
    const homeModule = resolveHomeModule(storedModule, getUserAccessibleModules(me.roleNames))
    // Permissions (overrides) but no role mapping to a module: nowhere to land.
    if (!homeModule) throw redirect({ to: '/unauthorized', search: { redirect: location.href } })

    // Stale stored module (never switched, or access removed): keep the switcher and sidebar in step.
    if (homeModule !== storedModule) store.set(activeModuleAtom, homeModule)

    throw redirect({ to: MODULE_CONFIG[homeModule].defaultPath })
  },
})
